import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import includes from 'lodash/includes';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';
import { DropdownItem } from 'reactstrap';

import store from 'Redux/store';
import { getDownloadUrl } from 'Redux/ducks/orders';
import ButtonDropdown from 'Components/Utility/ButtonDropdown';
import DropdownToggle from 'Components/Utility/DropdownToggle';
import DropdownMenu from 'Components/Utility/DropdownMenu';
import formatFileSize from 'Helpers/Format/FormatFileSize';

const downloadFile = async (file, orderID) => {
  const { signedGetUrl, key } = await store.dispatch(getDownloadUrl(orderID, file._id));

  const link = document.createElement('a');
  link.download = key.split('.').slice(1).join('.');
  link.href = signedGetUrl;

  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: false,
  });

  link.dispatchEvent(clickEvent);
};

const OrderDownloadsButton = ({ game, orderID, extras }) => {
  const [groupDownloadOpen, setGroupDownloadOpen] = useState(false);
  const [downloadsOpen, setDownloadsOpen] = useState({});

  const downloads = game.downloads.filter(download =>
    !download.is_sample && !download.is_group && download.files && download.files.length);

  const groupDownloads = game.downloads.filter(download =>
    !download.is_sample && download.is_group && download.files && download.files.length);

  const comicTypes = [];
  downloads.forEach((download) => {
    download.files.forEach((file) => {
      if (includes(comicTypes, file.format)) {
        return;
      }
      comicTypes.push(file.format);
    });
  });

  return (
    <div className="download-buttons-container">
      {comicTypes.sort().map(type => (
        <ButtonDropdown
          isOpen={downloadsOpen[`${type}`]}
          toggle={() => { setDownloadsOpen({ [`${type}`]: !downloadsOpen[`${type}`] }); }}
          className="download-button"
          key={type}
        >
          <DropdownToggle caret color="primary">
            {game.type !== 'video' &&
              <React.Fragment>
                {type}
              </React.Fragment>
            }
            {game.type === 'video' &&
              <FormattedMessage id="order-downloads-button.download-dropdown.code" defaultMessage="Code Files" />
            }
          </DropdownToggle>
          <DropdownMenu end>
            {downloads.map(download => (
              <div key={download._id} className="download-item">
                {filter(download.files, ['format', type]).map((file) => {
                  let fileFormat = file.format.toUpperCase();
                  if (file.format === 'zip' && includes(file.path.toLowerCase(), 'mp3')) {
                    fileFormat = 'MP3';
                  }
                  if (file.format === 'zip' && includes(file.path.toLowerCase(), 'wav') && !includes(game.name, 'SFX Pack')) {
                    fileFormat = 'WAV';
                  }
                  if (file.format === 'zip' && includes(file.path.toLowerCase(), 'wav') && includes(game.name, 'SFX Pack')) {
                    fileFormat = 'WMA';
                  }

                  return (
                    <DropdownItem
                      key={file._id}
                      color="primary"
                      title={`MD5 Hash - ${file.md5}`}
                      onClick={() => downloadFile(file, orderID)}
                    >
                      {download.name &&
                        <span className="issue-name">
                          {download.name}&nbsp;
                        </span>
                      }
                      {!download.name && download.files.length > 1 &&
                        <span className="issue-name">
                          {file.path.replace(`${file.md5}.`, '')}&nbsp;
                        </span>
                      }
                      <span>
                        <span className="issue-format">
                          {fileFormat}&nbsp;
                        </span>
                        <span className="issue-file-size">
                          ({formatFileSize(file.size)})
                        </span>
                      </span>
                    </DropdownItem>
                  );
                })}
              </div>
            ))}
          </DropdownMenu>
        </ButtonDropdown>
      ))}

      {!isEmpty(groupDownloads) &&
        <ButtonDropdown
          isOpen={groupDownloadOpen}
          toggle={() => { setGroupDownloadOpen(!groupDownloadOpen); }}
          className="download-button"
        >
          <DropdownToggle caret color="primary">
            {game.type !== 'video' && !extras &&
              <FormattedMessage id="order-downloads-button.download-all-button.all" defaultMessage="All" />
            }
            {game.type === 'video' && !extras &&
              <FormattedMessage id="order-downloads-button.download-all-button.video" defaultMessage="Videos" />
            }
            {extras &&
              <FormattedMessage id="order-downloads-button.download-all-button.extras" defaultMessage="Extras" />
            }
          </DropdownToggle>
          <DropdownMenu end>
            {groupDownloads.map(download => sortBy(download.files, ['format']).map(file => (
              <div key={download._id} className="download-item">
                <DropdownItem
                  key={file._id}
                  color="primary"
                  title={`MD5 Hash - ${file.md5}`}
                  onClick={() => downloadFile(file, orderID)}
                >
                  {download.name &&
                    <span className="issue-name">
                      {download.name}&nbsp;
                    </span>
                  }
                  {!download.name && download.files.length > 1 &&
                    <span className="issue-name">
                      {file.path.replace(`${file.md5}.`, '')}&nbsp;
                    </span>
                  }
                  <span>
                    <span className="issue-format">
                      {file.format.toUpperCase()}&nbsp;
                    </span>
                    <span className="issue-file-size">
                      ({formatFileSize(file.size)})
                    </span>
                  </span>
                </DropdownItem>
              </div>
            )))}
          </DropdownMenu>
        </ButtonDropdown>
      }
    </div>
  );
};

OrderDownloadsButton.propTypes = {
  game: PropTypes.shape({}),
  orderID: PropTypes.string.isRequired,
  extras: PropTypes.bool,
};

OrderDownloadsButton.defaultProps = {
  game: {},
  extras: false,
};

export default OrderDownloadsButton;
